import gql from "graphql-tag"

const UPDATE_SHIPPING_FEE_MODIFICATION = gql`
  mutation updateOrderModificationShippingFees($modificationId: ID!, $input: InputOrderModificationShippingFees!) {
    Order {
      updateOrderModificationShippingFees(modificationId: $modificationId, input: $input) {
        id
      }
    }
  }
`

export default UPDATE_SHIPPING_FEE_MODIFICATION
